"use client";
import Image from "next/image";

export const SpandaProVeterinary = ({ scrollPosition, isMobile }) => {
  const dots = [
    {
      dotTop: isMobile ? "9%" : "4%",
      dotLeft: isMobile ? "42%" : "46%",
      boxTop: isMobile ? "11%" : "4%",
      boxLeft: "48%",
      fadeStart: isMobile ? 10 : 22,
      fadeEnd: isMobile ? 50 : 200,
      content: (
        <div>
          <h3
            className="mb-2 text-lg font-bold"
            style={{ fontSize: isMobile ? "12px" : "16px" }}
          >
            High Quality Chest Piece
          </h3>
          <p>High Tech microphone for low frequency sound detection.</p>
        </div>
      ),
    },
    {
      dotTop: isMobile ? "18%" : "20%",
      dotLeft: "40%",
      boxTop: "20%",
      boxLeft: isMobile ? "0%" : "42%",
      boxright: isMobile ? "55%" : "0%",
      fadeStart: isMobile ? 40 : 150,
      fadeEnd: isMobile ? 90 : 200,
      content: (
        <div>
          <h3
            className="mb-2 text-lg font-bold"
            style={{ fontSize: isMobile ? "12px" : "16px" }}
          >
            Extended Tube
          </h3>
          <ul className="list-disc pl-6">
            <li>Easier to examine large or hard-to-reach animals.</li>
            <li>Interchangeable with a shorter tube.</li>
          </ul>
        </div>
      ),
    },

    {
      dotTop: "31%",
      dotLeft: "80%",
      boxTop: "33%",
      boxLeft: isMobile ? "50%" : "78%",
      fadeStart: isMobile ? 100 : 400,
      fadeEnd: isMobile ? 150 : 450,
      content: (
        <div>
          <h3
            className="mb-2 text-lg font-bold"
            style={{ fontSize: isMobile ? "12px" : "16px" }}
          >
            High Amplification for clear hearing
          </h3>
          <ul className="list-disc pl-6">
            <li>Soft Silicon Earbud.</li>
            <li>Custom designed speakers for low frequency sounds.</li>
          </ul>
        </div>
      ),
    },
    {
      dotTop: "44%",
      dotLeft: "32%",
      boxTop: "46%",
      boxright: isMobile ? "52%" : "67%",
      fadeStart: isMobile ? 200 : 700,
      fadeEnd: isMobile ? 300 : 800,
      content: (
        <div>
          <h3
            className="mb-2 text-lg font-bold"
            style={{ fontSize: isMobile ? "12px" : "16px" }}
          >
            User friendly Operation Console
          </h3>
          <ul className="list-disc pl-6">
            <li>Long life battery</li>
            <li>Ease of use with Indications & Tactile buttons</li>
            <li>Focus Modes (Cardiac, Pulmonary and Wide)</li>
            <li>Audio Recording and Sharing Service.</li>
            <li>Live Streaming</li>
            <li>AI for arrhythmia prediction</li>
            <li>OTA updates</li>
          </ul>
        </div>
      ),
    },
    {
      dotTop: "70%",
      dotLeft: "90%",
      boxTop: "71%",
      boxLeft: isMobile ? "70%" : "85%",
      fadeStart: isMobile ? 250 : 1100,
      fadeEnd: isMobile ? 150 : 1300,
      content: (
        <div>
          <h3
            className="mb-2 text-lg font-bold"
            style={{ fontSize: isMobile ? "12px" : "16px" }}
          >
            Tubing
          </h3>
          <ul className="list-disc pl-6">
            <li>Durable</li>
            <li>Latex free</li>
            <li>Easy to use</li>
          </ul>
        </div>
      ),
    },
  ];
  return (
    <div className="relative flex items-center justify-center">
      <div className="w-500 h-700 relative content-center justify-center overflow-hidden">
        <Image
          src="/images/blog/Spanda_pro_veterinary.png"
          alt="Spanda Pro Digital Stethoscope for Veterinary — AI-Powered Auscultation for Animals"
          width={1000}
          height={2000}
          className="h-full w-full content-center justify-center"
        />
        {dots.map((dot, index) => (
          <div key={index}>
            <div
              className={`absolute ${isMobile ? "h-2 w-2" : "h-4 w-4"} rounded-full bg-red-500`}
              style={{
                top: dot.dotTop,
                left: dot.dotLeft,
                opacity: Math.max(
                  0,
                  Math.min(1, (scrollPosition - dot.fadeStart) / 200),
                ),
              }}
            ></div>
            {scrollPosition > dot.fadeStart && (
              <div
                className="tooltip-box absolute rounded-md border border-gray-300 bg-white p-4 shadow-md"
                style={{
                  top: dot.boxTop,
                  left: dot.boxLeft,
                  right: dot.boxright,
                  fontSize: isMobile ? "12px" : "16px", // Adjust font size for mobile
                  opacity: Math.max(
                    0,
                    Math.min(1, (scrollPosition - dot.fadeStart) / 100),
                  ),
                }}
              >
                {dot.content}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
